<h2>
  Associated Plans
</h2>
<!--<div class="add-plan">-->
<!--  Add Plan-->
<!--</div>-->

<div class="row" [hidden]="associatedPlans.length == 0">
  <div class="col-xs-12">
    @if (associatedPlans && associatedPlans.length) {
      <p-table
        [value]="associatedPlans"
        [totalRecords]="totalRecords"
        [paginator]="true"
        [rows]="rows"
        [first]="first"
        [showCurrentPageReport]="true"
        selectionMode="single"
        [(selection)]="selectedAssociatedPlan"
        (onRowSelect)="onRowSelect($event)"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        stateStorage="session"
        stateKey="state-session-associated-plans"
        >
        <ng-template pTemplate="header">
          <tr>
            @for (key of keys; track key) {
              <th pSortableColumn="{{ key }}">
                {{ tableConfig?.columns[key]?.title }} <p-sortIcon field="{{ key }}"></p-sortIcon>
              </th>
            }
          </tr>
          <tr>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="name"
                [placeholder]="placeholders['name']"
                ariaLabel="Filter name"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="auth_required"
                [placeholder]="placeholders['auth_required']"
                ariaLabel="Filter auth required"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="brokered_transport"
                [placeholder]="placeholders['brokered_transport']"
                ariaLabel="Filter brokered transport"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="updated_at"
                [placeholder]="placeholders['updated_at']"
                ariaLabel="Filter updated at"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-associatedPlan>
          <tr [pSelectableRow]="associatedPlan">
            @for (key of keys; track key) {
              <td>{{ associatedPlan?.[key] }}</td>
            }
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>

<div [hidden]="associatedPlans.length > 0">
  <div class="empty-state">
    <div class="empty-state-content">
      <span>No associated plans for this carrier</span>
    </div>
  </div>
</div>
